
import { mapGetters } from 'vuex'
import TopBanner from './plp-content/topBanner.vue'
import RelatedCategories from './relatedCategories.vue'
import {
  parseBreadcrumbs,
  parseBreadcrumbsRelatedCategories,
} from '~/helpers/shopify/breadcrumbs'

export default {
  components: {
    TopBanner,
    RelatedCategories,
  },
  computed: {
    ...mapGetters({
      vxBreadcrumbs: 'common/getBreadcrumbs',
    }),
    breadcrumbs() {
      if (!this.vxBreadcrumbs) return []
      return parseBreadcrumbs(
        [this.$route.params.handle],
        this.vxBreadcrumbs,
        this.$i18n.locale
      )
    },
    relatedCategories() {
      return parseBreadcrumbsRelatedCategories(
        this.breadcrumbs,
        this.vxBreadcrumbs,
        this.$i18n.locale
      )
    },
    level1() {
      return this.breadcrumbs?.[0] || null
    },
    level2() {
      return this.breadcrumbs?.[1] || null
    },
    level3() {
      return this.breadcrumbs?.[2] || null
    },
    level4() {
      return this.breadcrumbs?.[3] || null
    },
  },
}
